import { render } from "./OtherLoginOptions.vue?vue&type=template&id=e7520da6&scoped=true"
import script from "./OtherLoginOptions.vue?vue&type=script&lang=js"
export * from "./OtherLoginOptions.vue?vue&type=script&lang=js"

import "./OtherLoginOptions.vue?vue&type=style&index=0&id=e7520da6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7520da6"]])

export default __exports__